import { useQuery } from "@tanstack/react-query";
import { USER_API } from "config";
import { useAxios } from "hooks/useAxios";
import { handleAxiosRequest } from "utils";

export type OtpProductCheckoutRow = {
  id: number;
  name: string;
  price: number;
  tier: "writer" | "studio";
  included_ai_credits: number;
  max_team_members: number;
  /** True when this row is the default workspace OTP SKU (see `resolveDefaultWorkspaceOtpProduct` on the backend). */
  is_default_workspace_otp: boolean;
};

function normalizeOtpProductsPayload(raw: unknown): OtpProductCheckoutRow[] {
  if (Array.isArray(raw)) {
    return raw;
  }
  if (raw && typeof raw === "object" && "data" in raw) {
    const inner = (raw as { data: unknown }).data;
    if (Array.isArray(inner)) {
      return inner as OtpProductCheckoutRow[];
    }
  }
  return [];
}

export function useOtpProducts(enabled: boolean) {
  const axios = useAxios();
  return useQuery({
    // `v2` busts stale cache from the pre-fix queryFn that incorrectly returned [].
    queryKey: ["payments", "otp-products", "v2"],
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<OtpProductCheckoutRow[]> => {
      const raw = await handleAxiosRequest<unknown>(axios.get(USER_API.otpProducts));
      return normalizeOtpProductsPayload(raw);
    },
  });
}
